import React from "react";

const SnookerMatchDetails = ({ games, userNames, styles }) => {
  return games.map((game, gameIndex) => {
    // Get player names using IDs
    const playerAName =
      game.playerA && userNames[game.playerA]
        ? userNames[game.playerA]
        : game.playerA === "guest"
        ? "Guest Player"
        : "Player A";

    const playerBName =
      game.playerB && userNames[game.playerB]
        ? userNames[game.playerB]
        : game.playerB === "guest"
        ? "Guest Player"
        : "Player B";

    return (
      <div key={gameIndex} style={{ marginBottom: "clamp(15px, 4vw, 20px)" }}>
        <p
          style={{
            fontSize: "clamp(14px, 3vw, 16px)",
            fontWeight: "600",
            marginBottom: "clamp(8px, 2vw, 10px)",
          }}
        >
          <strong>Game #{gameIndex + 1}</strong>
        </p>
        <p
          style={{
            fontSize: "clamp(13px, 2.5vw, 15px)",
            marginBottom: "clamp(8px, 2vw, 10px)",
          }}
        >
          <strong>Game Type:</strong> {game.gameType}
        </p>
        <p
          style={{
            fontSize: "clamp(13px, 2.5vw, 15px)",
            marginBottom: "clamp(8px, 2vw, 10px)",
          }}
        >
          <strong>Players:</strong> {playerAName} vs {playerBName}
        </p>
        <p
          style={{
            fontSize: "clamp(13px, 2.5vw, 15px)",
            marginBottom: "clamp(8px, 2vw, 10px)",
          }}
        >
          <strong>Winner:</strong>{" "}
          {game.winner === null
            ? "Draw"
            : game.winner === "user"
            ? playerAName
            : game.winner === "opponent"
            ? playerBName
            : "N/A"}
        </p>
        <p
          style={{
            fontSize: "clamp(13px, 2.5vw, 15px)",
            marginBottom: "clamp(8px, 2vw, 10px)",
          }}
        >
          <strong>{playerAName} Score:</strong> {game.userScore}
        </p>
        <p
          style={{
            fontSize: "clamp(13px, 2.5vw, 15px)",
            marginBottom: "clamp(8px, 2vw, 10px)",
          }}
        >
          <strong>{playerBName} Score:</strong> {game.opponentScore}
        </p>

        {game.attempts && game.attempts.length > 0 && (
          <>
            <h4
              style={{
                color: "#2c3e50",
                marginBottom: "clamp(10px, 2.5vw, 15px)",
                fontSize: "clamp(15px, 3vw, 18px)",
              }}
            >
              Shot Details
            </h4>
            <table style={styles.setsTable}>
              <thead>
                <tr>
                  <th style={styles.tableTh}>Shot By</th>
                  <th style={styles.tableTh}>Ball Color</th>
                  <th style={styles.tableTh}>Points</th>
                </tr>
              </thead>
              <tbody>
                {game.attempts.map((attempt, attemptIndex) => (
                  <tr key={attemptIndex}>
                    <td style={styles.tableTd}>
                      {attempt.shotBy === "user" ? playerAName : playerBName}
                    </td>
                    <td style={styles.tableTd}>
                      <span style={{ textTransform: "capitalize" }}>
                        {attempt.ballColor}
                      </span>
                    </td>
                    <td style={styles.tableTd}>{attempt.points}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </div>
    );
  });
};

export default SnookerMatchDetails;
